import { DependencyList, useEffect, useState } from "react";

type AsyncMemoState<T> =
  | {
      isLoading: false;
      value: T;
    }
  | {
      isLoading: true;
      value?: never;
    };

export const useAsyncMemo = <T>(callback: () => Promise<T>, deps: DependencyList): [T, false] | [undefined, true] => {
  const [state, setState] = useState<AsyncMemoState<T>>({
    isLoading: true,
  });

  useEffect(() => {
    let canceled = false;
    setState({
      isLoading: true,
    });
    callback().then((value) => {
      if (!canceled) {
        setState({
          isLoading: false,
          value,
        });
      }
    });
    return () => {
      canceled = true;
    };
  }, [...deps]);

  return [state.value, state.isLoading] as [T, false] | [undefined, true];
};
